/** @format */

import { apiCache, CACHE_DURATION } from "@/lib/cache";
import api from "../interceptor";
import { AxiosResponse } from "axios";

const url = "/stores";

const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

export const StoreAPI = {
  getStoreInfo: async () => {
    const cacheKey = `store_cache_key_${storeID}`;

    return await apiCache.getOrFetch<AxiosResponse>(
      cacheKey,
      CACHE_DURATION.FIVE_MINUTES,
      async () => {
        console.log(`🌐 Đang gọi Fetch Store Info `);

        return await api({
          method: "GET",
          url: `${url}/${storeID}`,
        });
      },
    );
  },
};
